import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
type Dot = {
  size: number;
  x: number;
  y: number;
  duration: number;
  delay: number;
  opacity: number;
};
// Deterministic pseudo-random for stable positions
function seeded(seed: number) {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}
function generateDots(count: number): Dot[] {
  const rand = seeded(42);
  const dots: Dot[] = [];
  for (let i = 0; i < count; i++) {
    const r = rand();
    // Size distribution: mostly tiny, some medium, few larger
    let size: number;
    if (r < 0.6) size = 2 + rand() * 4; // tiny: 2-6px
    else if (r < 0.9) size = 6 + rand() * 10; // small: 6-16px
    else size = 16 + rand() * 20; // medium: 16-36px
    dots.push({
      size,
      x: rand() * 100,
      y: rand() * 100,
      duration: 6 + rand() * 8,
      delay: rand() * 6,
      opacity: 0.15 + rand() * 0.25
    });
  }
  return dots;
}
export function FloatingOrbs() {
  const dots = useMemo(() => generateDots(90), []);
  return <div aria-hidden className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-37">
      {dots.map((dot, i) => <motion.div key={i} className="absolute rounded-full bg-brand-gold" style={{
      width: dot.size,
      height: dot.size,
      left: `${dot.x}%`,
      top: `${dot.y}%`,
      opacity: dot.opacity
    }} animate={{
      y: [0, -12, 0, 8, 0],
      opacity: [dot.opacity, dot.opacity * 0.5, dot.opacity]
    }} transition={{
      duration: dot.duration,
      delay: dot.delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-38" />)}
    </div>;
}